export default {
  listaTransferencias: [],
  transferencia: {
    id: null,
    contaOrigem: null,
    contaDestino: null,
    data: null,
    valor: 0,
    obs: '',
  },
}
